var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCohereLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cohere_idKpB5u1dr_6 1",
    clipPath: "url(#clip0_903_16872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.832 10.728C6.312 10.728 7.272 10.704 8.616 10.152C10.176 9.504 13.248 8.352 15.48 7.152C17.04 6.312 17.712 5.208 17.712 3.72C17.712 1.68 16.056 0 13.992 0H5.352C2.4 0 0 2.4 0 5.352C0 8.304 2.256 10.728 5.832 10.728Z",
    fill: "#39594D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2959 14.3999C7.2959 12.9599 8.1599 11.6399 9.5039 11.0879L12.2159 9.95994C14.9759 8.83194 17.9999 10.8479 17.9999 13.8239C17.9999 16.1279 16.1279 17.9999 13.8239 17.9999H10.8719C8.9039 17.9999 7.2959 16.3919 7.2959 14.3999Z",
    fill: "#D18EE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.096 11.424C1.392 11.424 0 12.816 0 14.52V14.928C0 16.608 1.392 18 3.096 18C4.8 18 6.192 16.608 6.192 14.904V14.496C6.168 12.816 4.8 11.424 3.096 11.424Z",
    fill: "#FF7759"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_903_16872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohereLogo);
export default __webpack_public_path__ + "static/media/cohere-logo.9be3c9bffdd12d0f6902888ba8f7e355.svg";
export { ForwardRef as ReactComponent };